import axios from "axios";
import { apiAddress } from "../settings";


 let apiURL = apiAddress + "/landing/api/";

export const  getLandingInfo = ()=> {
    return axios
      .get(apiURL + "contents/")
      .then(function (response) {
        return {
          success: true,
          data: response.data,
        };
      })
      .catch(function (error) {
        return {
          success: false,
          error: error.response,
        };
      });
  }


